import { render, staticRenderFns } from "./Submenu.vue?vue&type=template&id=0510e72a&scoped=true&"
import script from "./Submenu.vue?vue&type=script&lang=ts&"
export * from "./Submenu.vue?vue&type=script&lang=ts&"
import style0 from "./Submenu.vue?vue&type=style&index=0&id=0510e72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0510e72a",
  null
  
)

export default component.exports